import HeroSection from "./HeroSection";
import NFTList from "./NFTList";

function Inventory() {
  return (
    <div className="">
      <HeroSection />
      <NFTList />
    </div>
  );
}

export default Inventory;
